<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'REGISTRATIONS', url: '/admin/registrations' },
    { label: 'CREATE_REGISTRAR' }
  ]"
></breadcrumbs>

<page-header title="CREATE_REGISTRAR"></page-header>

<card>
  <form class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-grouped">
      <div class="control">
        <button
          [disabled]="isLoading"
          type="submit"
          class="button is-success"
          translationEditableDirective="SUBMIT"
          (click)="onSubmit($event)"
        >
          {{ 'SUBMIT' | translate }}
        </button>
      </div>
      <div class="control">
        <a
          [routerLink]="['/admin/registrations']"
          class="button is-link is-light"
          translationEditableDirective="CANCEL"
          >{{ 'CANCEL' | translate }}</a
        >
      </div>
    </div>
  </form>
</card>
